module.exports = __webpack_public_path__ + "static/audit-result-f0fa28162561e7330098ce52a674bf18.png";